import script from "./GeraiManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GeraiManager.vue?vue&type=script&setup=true&lang=js"

import "./GeraiManager.vue?vue&type=style&index=0&id=5873ecd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5873ecd6"]])

export default __exports__